// ---------------- CREATE COMPLAINT ----------------
export const CREATE_COMPLAINT_REQUEST = "CREATE_COMPLAINT_REQUEST";
export const CREATE_COMPLAINT_SUCCESS = "CREATE_COMPLAINT_SUCCESS";
export const CREATE_COMPLAINT_FAIL = "CREATE_COMPLAINT_FAIL";

// ---------------- MY COMPLAINTS ----------------
export const MY_COMPLAINTS_REQUEST = "MY_COMPLAINTS_REQUEST";
export const MY_COMPLAINTS_SUCCESS = "MY_COMPLAINTS_SUCCESS";
export const MY_COMPLAINTS_FAIL = "MY_COMPLAINTS_FAIL";

// ---------------- ADMIN COMPLAINTS ----------------
export const ADMIN_COMPLAINTS_REQUEST = "ADMIN_COMPLAINTS_REQUEST";
export const ADMIN_COMPLAINTS_SUCCESS = "ADMIN_COMPLAINTS_SUCCESS";
export const ADMIN_COMPLAINTS_FAIL = "ADMIN_COMPLAINTS_FAIL";

export const ASSIGN_COMPLAINT_REQUEST = "ASSIGN_COMPLAINT_REQUEST";
export const ASSIGN_COMPLAINT_SUCCESS = "ASSIGN_COMPLAINT_SUCCESS";
export const ASSIGN_COMPLAINT_FAIL = "ASSIGN_COMPLAINT_FAIL";

// ---------------- STORE COMPLAINTS ----------------
export const STORE_COMPLAINTS_REQUEST = "STORE_COMPLAINTS_REQUEST";
export const STORE_COMPLAINTS_SUCCESS = "STORE_COMPLAINTS_SUCCESS";
export const STORE_COMPLAINTS_FAIL = "STORE_COMPLAINTS_FAIL";

// ---------------- UPDATE STATUS ----------------
export const UPDATE_COMPLAINT_STATUS_REQUEST =
  "UPDATE_COMPLAINT_STATUS_REQUEST";
export const UPDATE_COMPLAINT_STATUS_SUCCESS =
  "UPDATE_COMPLAINT_STATUS_SUCCESS";
export const UPDATE_COMPLAINT_STATUS_FAIL =
  "UPDATE_COMPLAINT_STATUS_FAIL";
